import * as OpenShadePicker from '@ori-events/open-shade-picker';
import { Placement } from '@ori/analytics-data';

import type { SearchProduct } from '../components';
import { mapSearchPreviewProductToShadePicker } from './mapSearchPreviewProductToShadePicker';

export const openShadePicker = (product: SearchProduct) => () => {
  window.dispatchEvent(
    new CustomEvent<OpenShadePicker.Data>(OpenShadePicker.Name, {
      detail: {
        productName: product.name,
        products: mapSearchPreviewProductToShadePicker(product),
        placement: Placement.TopNavigationSearchSuggestions,
        productCode: product.code,
      },
    }),
  );
};
